import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import { useDebugValue } from "react";
import useUpdate from "./useUpdate";
import usePersist from "./usePersist";
import useSafeState from "./useSafeState";
import useLatestRef from "./useLatestRef";
import useThrottle from "./useThrottle";
function useThrottledValue(value, options) {
  var valueRef = useLatestRef(value);
  var _useSafeState = useSafeState(value),
    _useSafeState2 = _slicedToArray(_useSafeState, 2),
    throttledValue = _useSafeState2[0],
    setThrottledValue = _useSafeState2[1];
  var _useThrottle = useThrottle(setThrottledValue, options),
    _useThrottle2 = _slicedToArray(_useThrottle, 2),
    updateThrottledValue = _useThrottle2[0],
    cancel = _useThrottle2[1].cancel;
  var flush = usePersist(function (finalValue) {
    cancel();
    if (arguments.length > 0) {
      setThrottledValue(finalValue);
    } else {
      setThrottledValue(valueRef.current);
    }
  });
  useUpdate(function () {
    updateThrottledValue(value);
  }, [value]);
  useDebugValue(throttledValue);
  return [throttledValue, {
    flush: flush,
    cancel: cancel
  }];
}
export default useThrottledValue;